import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import { FullStory, init } from '@fullstory/browser';
import { fullStoryIntegration } from '@sentry/fullstory';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';


import App from "./App";

const SENTRY_FULLSTORY_STAGES = new Set(["staging", "production"]);

const stage = process.env.REACT_APP_STAGE;
if (SENTRY_FULLSTORY_STAGES.has(stage)) {
	init({ orgId: "12EXGZ" });

	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		integrations: [fullStoryIntegration(process.env.REACT_APP_SENTRY_ORG_SLUG, { client: FullStory })],
		tracesSampleRate: 1.0,
		environment: stage
	});
}

// Component to display friendly UI error instead of a blank page when error occurs
function FallbackComponent() {
	return <div className="text-center">
		<p className="h1">An error has ocurred.</p>
	</div>
}


ReactDOM
	.createRoot(document.getElementById("root"))
	.render(
		<Sentry.ErrorBoundary fallback={<FallbackComponent />}>
			<App />
		</Sentry.ErrorBoundary>
	);
